import { StatusCodes } from "http-status-codes"
import ResponseError from "./ResponseError"

export const RetryConfig = {
  retry: (failureCount: number, error: ResponseError): boolean => {
    switch (error.statusCode) {
      case StatusCodes.UNAUTHORIZED:
      case StatusCodes.BAD_REQUEST:
      case StatusCodes.NOT_FOUND:
        return false
      default:
        return failureCount < 3
    }
  }
}
